export default __webpack_public_path__ + "static/media/brust.24fe290a.jpg";